import i18next from 'containers/App/i18n';
import { isAxiosError } from 'paymentIntegrations';

function isCommunicationError(errorCode: number) {
  return errorCode === 120;
}

export async function getSwedbankErrorMessage(
  error: unknown,
  defaultMessage: string,
): Promise<string> {
  if (isAxiosError(error)) {
    const loadNamespace = i18next.loadNamespaces('settingsPayment');
    const t = (key: string) => loadNamespace.then(() => i18next.t(key));
    const errorCode = error.response?.data?.errorCode ?? -1;
    const actualError =
      error.response?.data?.errorMessage ??
      error.response?.data?.message ??
      defaultMessage;
    const extraText = isCommunicationError(errorCode)
      ? await t('paymentIntegrations:swedbank.messages.contactSupport')
      : '';
    if (extraText.length) {
      return `${actualError}\n\n${extraText}`;
    }
    return actualError;
  }
  if (error instanceof Error) {
    return error.message ?? defaultMessage;
  }
  return defaultMessage;
}
